import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_notifications),
    _createVNode(_component_router_view, { class: "min-h-screen bg-dayBg dark:bg-nightBg text-gray-600 dark:text-[#9CA3AF] font-archivo break-words" })
  ]))
}